const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EMAIL_EXISTS_ERROR = 'This email is already used for another user';
export const EMAIL_CHECK_FAILED_ERROR =
  "We couldn't check if this email is already in use. Please try again.";

export function isValidEmailFormat(email: string): boolean {
  return EMAIL_REGEX.test(email);
}
